import React from "react";

import "./ThemeSection.scss";

const ThemeSection = props => {
  return <div className="ThemeSection">{props.children}</div>;
};

export default ThemeSection;
